var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { MoreShapes } from "apparatus/draw";
import { Gradients } from "apparatus/gradients";
import { P } from "apparatus/library/common";
import { Group, Path } from "paper";
import { staticImplements } from "types";
let Diode = class Diode {
    render(appearance) {
        const { graphic } = renderDiode(appearance);
        return {
            graphic,
            hitShape: graphic.rectHitShape(),
            snapping: [
                { type: "wire", at: P(0, -50) },
                { type: "wire", at: P(0, 50) },
            ]
        };
    }
};
Diode.properties = {
    label: "Diode",
    defaultAppearance: {},
    appearanceSpecs: [],
};
Diode = __decorate([
    staticImplements()
], Diode);
export { Diode };
function renderDiode(appearance) {
    const diameter = 16;
    const height = 24;
    const height2 = 5;
    let { body, top, outline } = MoreShapes.cylinder3d({ diameter, height });
    body.withGradientFill("right", Gradients.cylinder("#444444".color()));
    top.withFill("#777777");
    outline.withStroke("default");
    let { body: body2, top: top2, outline: outline2 } = MoreShapes.cylinder3d({ diameter, height: height2 });
    top2.remove();
    outline2.remove();
    body2.bounds.top = body.bounds.top;
    body2.withGradientFill("right", Gradients.cylinder("#777777".color()));
    // Combine and add wire
    const graphic = new Group([
        new Path.Line(P(0, 0), P(0, 50)).withStroke("default"),
        body, body2, top, outline,
        new Path.Line(P(0, -50), P(0, -height / 2)).withStroke("default"),
    ]);
    return { graphic };
}
